export default function GreenChip({ label }: { label: string }) {
    return (
        <div
            className={
                'h-fit w-fit rounded-xl bg-green-100 px-2 py-1 text-xs font-bold text-green-700'
            }
        >
            {label}
        </div>
    )
}
